"use client";
import React, { useState } from "react";
import { BANKER } from "@/constants";
import { RecentLeaderContext } from "@/context/RecentLeaderBoardContext";
import { useContext } from "react";

const MatchHistoryHeader = ({ isHome }) => {
  const { group1, group2, setGroup1, setGroup2 } = useContext(RecentLeaderContext);

  const handleCompanyChange = (value) => {
    const { name, banker, oddType } = value;
    if (name === 'group1') {
      setGroup1({ banker, oddType });
    } else {
      setGroup2({ banker, oddType });
    } 
  };

  return (
    <div
      className={
        `${isHome ? "bg-button-blue-bet dark:bg-blue-bar text-white" : "bg-[#FFC839] text-button-blue-bet"} flex flex-row justify-center items-center mt-[18px] p-[5px] gap-1 text-center text-xxs rounded font-semibold`
      }
    >
      <div className={"w-1/12"}>Giải đấu</div>
      <div className={"w-1/12"}>Ngày</div>
      <div className={"w-2/12"}>Chủ</div>
      <div className={"w-1/12"}>Tỷ số</div>
      <div className={"w-2/12"}>Khách</div>
      <div className={"w-1/12"}>Phạt góc</div>
      <div className={"w-3/12 flex flex-col gap-1"}>
        <CompanyFilter name="group1" value={group1} onChange={handleCompanyChange} />

        <div className={"flex flex-row justify-between items-center "}>
          <div className="flex-1 text-center">Chủ</div>
          <div className="flex-1 text-center">Hòa</div>
          <div className="flex-1 text-center">Khách</div>
          <div className="flex-1 text-center">T/B</div>
        </div>
      </div>
      <div className={"w-3/12 flex flex-col gap-1"}>
        <CompanyFilter name="group2" value={group2} onChange={handleCompanyChange} />

        <div className={"flex flex-row justify-between items-center "}>
          <div className="flex-1 text-center">Chủ</div>
          <div className="flex-1 text-center">HDC</div>
          <div className="flex-1 text-center">Khách</div>
          <div className="flex-1 text-center">HDC</div>
        </div>
      </div>
      <div className={"w-1/12"}>T/X</div>
    </div>
  );
};

const BankerSelect = ({ value, onChange }) => {
  return (
    <select
      className={"w-full bg-white max-w-[128px] rounded text-black"}
      value={value}
      onChange={onChange}
    >
      {BANKER.map((item) => (
        <option key={item.value} value={item.value}>
          {item.name}
        </option>
      ))}
    </select>
  );
};

const OddTypeSelect = ({ value, onChange }) => {
  return (
    <select
      className={"w-full bg-white max-w-[128px] rounded text-black"}
      value={value}
      onChange={onChange}
    >
      <option value="initial">Ban đầu</option>
      <option value="instant">Cuối cùng</option>
    </select>
  );
};

const CompanyFilter = ({ name, value, onChange }) => {
  const [banker, setBanker] = useState(value.banker);
  const [oddType, setOddType] = useState(value.oddType);

  const handleBankerChange = (value) => {
    setBanker(value);
    onChange({ name, banker: value, oddType });
  };

  const handleOddTypeChange = (value) => {
    setOddType(value);
    onChange({ name, banker, oddType: value });
  };

  return (
    <div className={"flex flex-row justify-between items-center gap-1"}>
      <BankerSelect
        value={banker}
        onChange={(e) => handleBankerChange(e.target.value)}
      />
      <OddTypeSelect
        value={oddType}
        onChange={(e) => handleOddTypeChange(e.target.value)}
      />
    </div>
  );
};

export default MatchHistoryHeader;
